var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.4167,
    height: 38,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1035 27.1655C26.2169 28.7936 23.7695 29.7764 21.0953 29.7764C15.1283 29.7764 10.291 24.883 10.291 18.8467C10.291 12.8104 15.1283 7.91699 21.0953 7.91699C23.7695 7.91699 26.2169 8.89985 28.1035 10.528C29.9902 8.89985 32.4375 7.91699 35.1117 7.91699C41.0788 7.91699 45.916 12.8104 45.916 18.8467C45.916 24.883 41.0788 29.7764 35.1117 29.7764C32.4375 29.7764 29.9902 28.7936 28.1035 27.1655Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1035 27.1655C30.4266 25.1608 31.8996 22.1778 31.8996 18.8467C31.8996 15.5157 30.4266 12.5327 28.1035 10.528C29.9902 8.89985 32.4375 7.91699 35.1117 7.91699C41.0788 7.91699 45.916 12.8104 45.916 18.8467C45.916 24.883 41.0788 29.7764 35.1117 29.7764C32.4375 29.7764 29.9902 28.7936 28.1035 27.1655Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1027 10.5283C30.4257 12.533 31.8988 15.516 31.8988 18.847C31.8988 22.1781 30.4257 25.161 28.1027 27.1658C25.7797 25.161 24.3066 22.1781 24.3066 18.847C24.3066 15.516 25.7797 12.533 28.1027 10.5283Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.eb635152fdd9f8cab079868c67fcbf26.svg";
export { ForwardRef as ReactComponent };